module.exports = __webpack_public_path__ + "static/media/photo-1.093950e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/alabama-rural-studio/photo-1.jpg
// module id = 149
// module chunks = 0